import { defineAsyncComponent, Component, AppContext } from 'vue';
const requireComponent = require.context('.', false, /.*\.vue$/)
const components = requireComponent
    .keys()
    .reduce<AppContext['components']>((components, fileName) => {
        components[fileName.replace(/(^\.\/)|(\.vue$)/g, '')] = defineAsyncComponent(async () => requireComponent(fileName).default);
        return components
    }, {})
export default components
